import { SelectOption } from '@shopify/polaris'
import { getTranslation } from './getTranslation'

export function getGoPayLanguageOptions(): SelectOption[] {
  return [
    { value: '' as any, label: getTranslation('common.automatically') },
    { value: 'CS', label: getTranslation('languages.czech') },
    { value: 'EN', label: getTranslation('languages.english') },
    { value: 'SK', label: getTranslation('languages.slovak') },
    { value: 'DE', label: getTranslation('languages.german') },
    { value: 'RU', label: getTranslation('languages.russian') },
    { value: 'PL', label: getTranslation('languages.polish') },
    { value: 'HU', label: getTranslation('languages.hungarian') },
    { value: 'FR', label: getTranslation('languages.french') },
    { value: 'RO', label: getTranslation('languages.romanian') },
    { value: 'BG', label: getTranslation('languages.bulgarian') },
    { value: 'HR', label: getTranslation('languages.croatian') },
    { value: 'IT', label: getTranslation('languages.italian') },
    { value: 'ES', label: getTranslation('languages.spanish') },
    { value: 'UK', label: getTranslation('languages.ukrainian') },
    { value: 'ET', label: getTranslation('languages.estonian') },
    { value: 'LT', label: getTranslation('languages.lithuanian') },
    { value: 'LV', label: getTranslation('languages.latvian') },
    { value: 'SL', label: getTranslation('languages.slovenian') },
    { value: 'PT', label: getTranslation('languages.portuguese') },
  ]
}

export function getGPWebPayLanguageOptions(): SelectOption[] {
  return [
    { value: '' as any, label: getTranslation('common.automatically') },
    { value: 'cs', label: getTranslation('languages.czech') },
    { value: 'sk', label: getTranslation('languages.slovak') },
    { value: 'en', label: getTranslation('languages.english') },
    { value: 'ar', label: getTranslation('languages.arabic') },
    { value: 'da', label: getTranslation('languages.danish') },
    { value: 'fi', label: getTranslation('languages.finnish') },
    { value: 'fr', label: getTranslation('languages.french') },
    { value: 'nl', label: getTranslation('languages.dutch') },
    { value: 'it', label: getTranslation('languages.italian') },
    { value: 'lv', label: getTranslation('languages.latvian') },
    { value: 'hu', label: getTranslation('languages.hungarian') },
    { value: 'de', label: getTranslation('languages.german') },
    { value: 'no', label: getTranslation('languages.norwegian') },
    { value: 'pl', label: getTranslation('languages.polish') },
    { value: 'pt', label: getTranslation('languages.portuguese') },
    { value: 'ru', label: getTranslation('languages.russian') },
    { value: 'es', label: getTranslation('languages.spanish') },
    { value: 'sv', label: getTranslation('languages.swedish') },
    { value: 'uk', label: getTranslation('languages.ukrainian') },
  ]
}

export function getComGateLanguageOptions(): SelectOption[] {
  return [
    { value: '' as any, label: getTranslation('common.automatically') },
    { value: 'cs', label: getTranslation('languages.czech') },
    { value: 'en', label: getTranslation('languages.english') },
    { value: 'sk', label: getTranslation('languages.slovak') },
    { value: 'pl', label: getTranslation('languages.polish') },
  ]
}
